import { createAction, props } from '@ngrx/store';
import { ReportTypes } from '@mode/shared/contract-common';

export const loadReportDbtMetadata = createAction(
  '[ReportDbtMetadata] LoadReportDbtMetadata',
  props<{
    accountId: string;
    reportToken: string;
  }>()
);

export const loadReportDbtMetadataSuccess = createAction(
  '[ReportDbtMetadata] LoadReportDbtMetadataSuccess',
  props<{
    dbtMetaData: ReportTypes.ReportDbtMetaData;
  }>()
);

export const loadReportDbtMetadataFailure = createAction(
  '[ReportDbtMetadata] LoadReportDbtMetadataFailure',
  props<{ error: any }>()
);

export type Union =
  | ReturnType<typeof loadReportDbtMetadata>
  | ReturnType<typeof loadReportDbtMetadataFailure>
  | ReturnType<typeof loadReportDbtMetadataSuccess>;
